module.exports = __webpack_public_path__ + "img/category_39.86fef79b.png";